<template>
    <div class="home">
        hello
    </div>
</template>

<script>
export default {

}
</script>
